import { createFileRoute } from "@tanstack/react-router";

import { CompaniesPage } from "@/pages/Admin";

export const Route = createFileRoute("/app/admin/companies/")({
  component: CompaniesPage,
});
